import { render, staticRenderFns } from "./CategoriesView.vue?vue&type=template&id=4cd7fda6&scoped=true"
import script from "./CategoriesView.vue?vue&type=script&lang=ts"
export * from "./CategoriesView.vue?vue&type=script&lang=ts"
import style0 from "./CategoriesView.vue?vue&type=style&index=0&id=4cd7fda6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd7fda6",
  null
  
)

export default component.exports